import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { VoucherPerfil } from 'src/app/models/voucher-perfil';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { VoucherService } from 'src/app/services/voucher.service';

@Component({
  selector: 'app-condicoes-voucher-modal',
  templateUrl: './condicoes-voucher-modal.component.html',
  styleUrls: ['./condicoes-voucher-modal.component.scss']
})
export class CondicoesVoucherModalComponent implements OnInit {

  voucher: any;
  perfis: VoucherPerfil[] = [];
  administrador = false;

  constructor(
    private dialogRef: MatDialogRef<CondicoesVoucherModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private voucherService: VoucherService,
    private globalService: GlobalService
  ) {
    if(this.data) {
      this.voucher = this.data.voucher;
    }
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();

    if (this.administrador) {
      this.buscarPerfis();
    }
  }

  buscarPerfis() {
    this.carregandoService.mostra('buscarPerfis');

    this.voucherService.consultarPerfis(this.voucher.id).subscribe(
      perfis => {
        this.perfis = perfis;
        this.carregandoService.esconde('buscarPerfis');
      },
      err => {
        this.carregandoService.esconde('buscarPerfis');
        this.notificacaoService.erro(err);
      });
  }

  fechar() {
    this.dialogRef.close();
  }
}
